import service from '@/utils/request'

function getFuelPlan(data, cancelToken) {
  return service({
    url: '/fleet/user/fuel_plan',
    method: 'post',
    data: data,
    headers: {
      'portal-token': true
    },
    cancelToken,
    timeout: 100000
  })
}

export default {
  getFuelPlan
}
